import React from 'react';

/**
 * Top-level error boundary so a runtime error never leaves the user with a
 * black screen. Captures errors thrown during render and shows a recoverable
 * fallback panel with the option to reload or sign out.
 */
class RootErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, info) {
    // eslint-disable-next-line no-console
    console.error('[RootErrorBoundary]', error, info?.componentStack);
  }

  handleReload = () => {
    try {
      // Belt-and-suspenders: also drop any stale caches before reloading.
      if ('caches' in window) {
        caches.keys().then((keys) => keys.forEach((k) => caches.delete(k)));
      }
    } catch (_) { /* ignore */ }
    window.location.reload();
  };

  handleSignOut = () => {
    try {
      localStorage.removeItem('obgh_token');
      localStorage.removeItem('obgh_user');
    } catch (_) { /* ignore */ }
    window.location.href = '/';
  };

  render() {
    if (!this.state.error) return this.props.children;
    const msg = this.state.error?.message || String(this.state.error);
    return (
      <div
        style={{
          minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center',
          padding: 24, background: '#0a0a0a', color: '#fff',
          fontFamily: 'system-ui, -apple-system, sans-serif',
        }}
        data-testid="root-error-boundary"
      >
        <div style={{ maxWidth: 480, width: '100%', textAlign: 'center' }}>
          <div style={{ fontSize: 12, letterSpacing: 4, color: '#f59e0b', fontWeight: 700, marginBottom: 12 }}>
            OBGH TERRITOIRE PRO
          </div>
          <h1 style={{ fontSize: 22, fontWeight: 800, marginBottom: 12, color: '#f59e0b' }}>
            Une erreur est survenue
          </h1>
          <p style={{ fontSize: 14, color: '#a1a1aa', lineHeight: 1.5, marginBottom: 20 }}>
            L&apos;application a rencontre un probleme. Essayez de recharger.
            Si l&apos;erreur persiste, deconnectez-vous puis reconnectez-vous.
          </p>
          <pre style={{
            background: '#18181b', color: '#fca5a5', border: '1px solid #3f3f46',
            padding: 10, fontSize: 11, textAlign: 'left', overflow: 'auto',
            maxHeight: 160, marginBottom: 20, borderRadius: 4,
          }}>
            {msg}
          </pre>
          <div style={{ display: 'flex', gap: 8, justifyContent: 'center', flexWrap: 'wrap' }}>
            <button
              onClick={this.handleReload}
              data-testid="root-error-reload"
              style={{
                padding: '10px 18px', background: '#f59e0b', color: '#000',
                border: 'none', fontWeight: 800, textTransform: 'uppercase',
                letterSpacing: 1.5, fontSize: 12, cursor: 'pointer',
              }}
            >
              RECHARGER
            </button>
            <button
              onClick={this.handleSignOut}
              data-testid="root-error-signout"
              style={{
                padding: '10px 18px', background: 'transparent', color: '#fff',
                border: '1px solid #3f3f46', fontWeight: 600, textTransform: 'uppercase',
                letterSpacing: 1.5, fontSize: 12, cursor: 'pointer',
              }}
            >
              Deconnexion
            </button>
          </div>
        </div>
      </div>
    );
  }
}

export default RootErrorBoundary;
